export const countriesWithCodesAndStates = [
  { countryName: 'Argentina', countryCode: 'AR', urlSlug: 'argentina' },
  { countryName: 'Australia', countryCode: 'AU', urlSlug: 'australia' },
  { countryName: 'Austria', countryCode: 'AT', urlSlug: 'austria' },
  { countryName: 'Belarus', countryCode: 'BY', urlSlug: 'belarus' },
  { countryName: 'Belgium', countryCode: 'BE', urlSlug: 'belgium' },
  { countryName: 'Brazil', countryCode: 'BR', urlSlug: 'brazil' },
  { countryName: 'Bulgaria', countryCode: 'BG', urlSlug: 'bulgaria' },
  { countryName: 'China', countryCode: 'CN', urlSlug: 'china' },
  { countryName: 'Colombia', countryCode: 'CO', urlSlug: 'colombia' },
  { countryName: 'Croatia', countryCode: 'HR', urlSlug: 'croatia' },
  { countryName: 'Denmark', countryCode: 'DK', urlSlug: 'denmark' },
  {
    countryName: 'Dominican Republic',
    countryCode: 'DO',
    urlSlug: 'dominican-republic',
  },
  { countryName: 'Estonia', countryCode: 'EE', urlSlug: 'estonia' },
  { countryName: 'Finland', countryCode: 'FI', urlSlug: 'finland' },
  { countryName: 'France', countryCode: 'FR', urlSlug: 'france' },
  { countryName: 'Georgia', countryCode: 'GE', urlSlug: 'georgia' },
  { countryName: 'Germany', countryCode: 'DE', urlSlug: 'germany' },
  { countryName: 'Greece', countryCode: 'GR', urlSlug: 'greece' },
  { countryName: 'Guatemala', countryCode: 'GT', urlSlug: 'guatemala' },
  { countryName: 'Hungary', countryCode: 'HU', urlSlug: 'hungary' },
  { countryName: 'India', countryCode: 'IN', urlSlug: 'india' },
  { countryName: 'Ireland', countryCode: 'IE', urlSlug: 'ireland' },
  { countryName: 'Italy', countryCode: 'IT', urlSlug: 'italy' },
  { countryName: 'Japan', countryCode: 'JP', urlSlug: 'japan' },
  { countryName: 'Latvia', countryCode: 'LV', urlSlug: 'latvia' },
  { countryName: 'Lithuania', countryCode: 'LT', urlSlug: 'lithuania' },
  { countryName: 'Mexico', countryCode: 'MX', urlSlug: 'mexico' },
  { countryName: 'New Zealand', countryCode: 'NZ', urlSlug: 'new-zealand' },
  { countryName: 'Nigeria', countryCode: 'NG', urlSlug: 'nigeria' },
  { countryName: 'Norway', countryCode: 'NO', urlSlug: 'norway' },
  { countryName: 'Panama', countryCode: 'PA', urlSlug: 'panama' },
  { countryName: 'Peru', countryCode: 'PE', urlSlug: 'peru' },
  { countryName: 'Philippines', countryCode: 'PH', urlSlug: 'philippines' },
  { countryName: 'Poland', countryCode: 'PL', urlSlug: 'poland' },
  { countryName: 'Portugal', countryCode: 'PT', urlSlug: 'portugal' },
  { countryName: 'Romania', countryCode: 'RO', urlSlug: 'romania' },
  { countryName: 'Serbia', countryCode: 'RS', urlSlug: 'serbia' },
  { countryName: 'Singapore', countryCode: 'SG', urlSlug: 'singapore' },
  { countryName: 'Slovakia', countryCode: 'SK', urlSlug: 'slovakia' },
  { countryName: 'Slovenia', countryCode: 'SI', urlSlug: 'slovenia' },
  { countryName: 'Spain', countryCode: 'ES', urlSlug: 'spain' },
  { countryName: 'Sweden', countryCode: 'SE', urlSlug: 'sweden' },
  { countryName: 'Switzerland', countryCode: 'CH', urlSlug: 'switzerland' },
  { countryName: 'Thailand', countryCode: 'TH', urlSlug: 'thailand' },
  { countryName: 'Turkey', countryCode: 'TR', urlSlug: 'turkey' },
  {
    countryName: 'United Kingdom',
    countryCode: 'GB',
    urlSlug: 'united-kingdom',
  },
  { countryName: 'Uruguay', countryCode: 'UY', urlSlug: 'uruguay' },
  {
    countryName: 'Canada',
    countryCode: 'CA',
    urlSlug: 'canada-alberta',
    stateOrProvince: 'Alberta',
  },
  {
    countryName: 'Canada',
    countryCode: 'CA',
    urlSlug: 'canada-british-columbia',
    stateOrProvince: 'British Columbia',
  },
  {
    countryName: 'Canada',
    countryCode: 'CA',
    urlSlug: 'canada-manitoba',
    stateOrProvince: 'Manitoba',
  },
  {
    countryName: 'Canada',
    countryCode: 'CA',
    urlSlug: 'canada-new-brunswick',
    stateOrProvince: 'New Brunswick',
  },
  {
    countryName: 'Canada',
    countryCode: 'CA',
    urlSlug: 'canada-newfoundland-and-labrador',
    stateOrProvince: 'Newfoundland and Labrador',
  },
  {
    countryName: 'Canada',
    countryCode: 'CA',
    urlSlug: 'canada-novia-scotia',
    stateOrProvince: 'Novia Scotia',
  },
  {
    countryName: 'Canada',
    countryCode: 'CA',
    urlSlug: 'canada-ontario',
    stateOrProvince: 'Ontario',
  },
  {
    countryName: 'Canada',
    countryCode: 'CA',
    urlSlug: 'canada-prince-edward-island',
    stateOrProvince: 'Prince Edward Island',
  },
  {
    countryName: 'Canada',
    countryCode: 'CA',
    urlSlug: 'canada-quebec',
    stateOrProvince: 'Quebec',
  },
  {
    countryName: 'Canada',
    countryCode: 'CA',
    urlSlug: 'canada-saskatchewan',
    stateOrProvince: 'Saskatchewan',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-arizona',
    stateOrProvince: 'Arizona',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-arkansas',
    stateOrProvince: 'Arkansas',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-california',
    stateOrProvince: 'California',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-colorado',
    stateOrProvince: 'Colorado',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-connecticut',
    stateOrProvince: 'Connecticut',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-florida',
    stateOrProvince: 'Florida',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-georgia',
    stateOrProvince: 'Georgia',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-illinois',
    stateOrProvince: 'Illinois',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-indiana',
    stateOrProvince: 'Indiana',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-kansas',
    stateOrProvince: 'Kansas',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-louisiana',
    stateOrProvince: 'Louisiana',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-maryland',
    stateOrProvince: 'Maryland',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-massachusetts',
    stateOrProvince: 'Massachusetts',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-michigan',
    stateOrProvince: 'Michigan',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-mississippi',
    stateOrProvince: 'Mississippi',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-missouri',
    stateOrProvince: 'Missouri',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-montana',
    stateOrProvince: 'Montana',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-nevada',
    stateOrProvince: 'Nevada',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-new-jersey',
    stateOrProvince: 'New Jersey',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-new-mexico',
    stateOrProvince: 'New Mexico',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-new-york',
    stateOrProvince: 'New York',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-north-carolina',
    stateOrProvince: 'North Carolina',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-ohio',
    stateOrProvince: 'Ohio',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-oklahoma',
    stateOrProvince: 'Oklahoma',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-oregon',
    stateOrProvince: 'Oregon',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-pennsylvania',
    stateOrProvince: 'Pennsylvania',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-south-carolina',
    stateOrProvince: 'South Carolina',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-south-dakota',
    stateOrProvince: 'South Dakota',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-tennessee',
    stateOrProvince: 'Tennessee',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-texas',
    stateOrProvince: 'Texas',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-utah',
    stateOrProvince: 'Utah',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-virginia',
    stateOrProvince: 'Virginia',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-washington',
    stateOrProvince: 'Washington',
  },
  {
    countryName: 'United States of America',
    countryCode: 'US',
    urlSlug: 'united-states-of-america-wisconsin',
    stateOrProvince: 'Wisconsin',
  },
  {
    countryName: 'Vietnam',
    countryCode: 'VN',
    urlSlug: 'vietnam',
  },
];
// 92 records in Airtable
